// import smsService from "../../api/reservePlanNew.service";
import telematicsService from "../../api/telematics.service";
import apiService from "../../api/api.service";
import { mapGetters } from "vuex";

import rules from "../../utils/rules";
import app from "@/utils/app.json";
// import XLSX from "xlsx";
// import moment from "moment";
export default {
  name: "scheduler-dialog",
  components: {},
  props: [
    "priority",
    "role",
    "reportName",
    "zonesList",
    "groups",
    "locations",
    "models",
    "jobSiteList",
  ],
  data() {
    return {
      loadergetcalls: false,
      reportsList: [],
      selectMonthlyDay: null,
      isReportLoading: false,
      timeframesList: app.timeframelist,
      scheduledtimeframe: "",
      loadinglocations: false,
      loadingzones: false,
      selectedUser: "",
      isLoaderUser: false,
      loading: false,
      loadinggroups: false,
      loadingmodel: false,
      selected: [
        "Dates",
        "Equipment",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Search Field",
      ],
      rules: rules,
      usersList: [],
      infoDialog: false,
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },
        { text: "Name", value: "name", width: "10px" },

        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },

        // { text: "Type", value: "workDayHours",width:"10px" },
        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",
      selectedcust: "",
      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      monthlyListDropDown: app.monthlylistdropdown,
      selectMonthly: "",
      searchFieldPOSchedule: "",
      searchFieldJobSchedule: "",

      searchEquipNameSchedule: "",

      searchSchedule: "",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,

      //  dailyUtilizationTargetSchedule:0,
      //  selectedTimeSchedule:"Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteScheduleName: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      machines: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      nodataMachine: false,
      showmachinmsg: true,
      // end scheduled reports data fields
    };
  },
  watch: {
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  mounted() {},
  methods: {
    showScheduleModal() {
      this.infoDialog = true;
      this.getScheduledList();
      // this.getJobSites();

      // this.getGroups();
      // this.getModels();
      // this.getZones();
    },
    // scheduled reports api calls
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    showScheduledForm() {
      this.readUsersFromAPI();
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    async readUsersFromAPI() {
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      try {
        let usersListRes;
        // debugger; // eslint-disable-line no-debugger
        this.isLoaderUser = true;
        if (customerId == "") {
          usersListRes = await apiService.getUsersAll();
        } else {
          usersListRes = await apiService.getUsersByCustId(customerId);
        }
        if (usersListRes) {
          this.isLoaderUser = false;
          this.usersList = usersListRes.data.map((d, index) => ({
            ...d,
            name: d.firstName + " " + d.lastName,
            sno: index + 1,
          }));
        }
      } catch (err) {
        this.$toast.error("Unable to load the users" + err);
        this.isLoaderUser = false;
      }
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";
      this.selectMonthlyDay = null;
      this.searchFieldPOSchedule = "";
      this.searchFieldJobSchedule = "";
      this.searchEquipNameSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    closeSchedule() {
      this.infoDialog = false;
      this.cancelSchedule();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";
      this.selectedUser = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.selectMonthlyDay = null;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
      this.selectedGroup = [];
      this.selectedMachineSchedule = [];
      this.selectedModelSchedule = [];
      this.selectedZoneSchedule = [];
      this.selectedJobSiteSchedule = [];
      this.selectedJobSiteScheduleName = [];
      this.searchEquipNameSchedule = "";
      this.searchFieldPOSchedule = "";
      this.searchFieldJobSchedule = "";
      this.searchEquipNameSchedule = "";
      this.searchContractIdSchedule = "";
    },

    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },

    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.jobSiteList.find((el) => el.locationId == locationId)
            .locationName
      );
    },

    // scheduled reports api calls
    clearTimeFrame() {
      this.scheduledtimeframe = "";
    },

    zoneChangeSchedule() {
      this.selectedZonesNamesSchedule = [];
      this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    jobSiteChangeSchedule() {
      this.selectedJobSiteScheduleName = [];
      this.selectedJobSiteScheduleName = this.selectedJobSiteSchedule.map(
        (locationId) =>
          this.jobSiteList.find((el) => el.locationId == locationId)
            .locationName
      );
    },
    modelChangeSchedule() {
      this.selectedModelNamesSchedule = [];
      this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },

    resetGroupSchedule() {
      this.selectedGroupSchedule = [];
      //  this.selectedGroupNamesSchedule =[];
      // this.readReportListFromAPI();
    },

    resetZoneSchedule() {
      this.selectedZoneSchedule = [];
      this.selectedZonesNamesSchedule = [];
    },
    resetMachineSchedule() {
      this.selectedMachineSchedule = [];
    },
    resetJobSiteSchedule() {
      this.selectedJobSiteSchedule = [];

      this.selectedJobSiteScheduleName = [];
    },

    resetModelSchedule() {
      this.selectedModelSchedule = [];
      this.selectedModelNamesSchedule = [];
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    async EditScheduleDialog(item) {
      this.scheduleedit = true;
      this.readUsersFromAPI();
      // this.scheduledialog = true;
      let dataser = "";
      this.loadergetcalls = true;
      this.displayScheduledForm = false;
      this.selectedUser = item.requestUserId;
      this.searchMachines(dataser);

      this.loadergetcalls = false;
      this.displayScheduledForm = true;

      this.selectedschedule = item;
      this.scheduleName = item.name;
      this.selectedcust = item.customerName;
      this.emails = item.emails.split(",");
      this.selectedDays =
        item.weekDays != null && item.weekDays != ""
          ? item.weekDays.split(",")
          : [];
      this.scheduledFrequency = item.frequency;
      this.scheduledType = item.format;
      this.displayScheduledForm = true;
      this.scheduledtimeframe = item.timeFrame;
      // filters
      this.selectMonthlyDay =
        item.day != null && item.day != "" ? item.day : null;

      item.parameters.filter((e) => {
        if (e.name == "machineIds" && e.value != "") {
          this.machineSearchFilterSchedule = e.value;

          this.selectedMachineSchedule = e.value.split(",");
        }
        if (e.name == "groupIds" && e.value != "") {
          this.selectedGroupSchedule = e.value.split(",");
        }
        if (e.name == "zone" && e.value != "") {
          console.log(e);
          this.selectedZoneSchedule = e.value.split(",");
          this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
            (id) => this.zonesList.find((el) => el.id == id).name
          );
        }
        if (e.name == "model" && e.value != "") {
          console.log(e);
          this.selectedModelSchedule = e.value.split(",");
          // this.selectedModelNamesSchedule = e.value.split(",");

          this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
            (id) => this.models.find((el) => el.id == id).name
          );
        }
        if (e.name == "jobSite" && e.value != "") {
          console.log(e);

          this.selectedJobSiteScheduleName = e.value.split(";");
          this.selectedJobSiteSchedule = this.selectedJobSiteScheduleName.map(
            (locationName) =>
              this.jobSiteList.find((el) => el.locationName == locationName)
                .locationId
          );
        }
        // if(e.name =='utilizationTargetValue' && e.value !=""){
        //  this.dailyUtilizationTargetSchedule = e.value;

        // }

        // if(e.name =='utilizationTargetType' && e.value !=""){
        //   console.log(e);
        //   this.selectedTimeSchedule = e.value;

        // }
        if (e.name == "searchKeyName" && e.value != "") {
          console.log(e);
          this.searchEquipNameSchedule = e.value;
        }
        if (e.name == "searchKey" && e.value != "") {
          console.log(e);
          this.searchFieldPOSchedule = e.value;
        }
        if (e.name == "searchKeyJob" && e.value != "") {
          console.log(e);
          this.searchFieldJobSchedule = e.value;
        }
        if (e.name == "contractId" && e.value != "") {
          console.log(e);
          this.searchContractIdSchedule = e.value;
        }
      });

      //end filters
    },
    async CreateSchedule() {
      this.isSaveScheduleLoading = true;
      let machineIds, zone, groupIds, jobSite, model;

      if (this.selectedMachineSchedule.length > 0) {
        machineIds = this.selectedMachineSchedule.join(",");
        console.log(machineIds);
      } else {
        machineIds = "";
      }
      if (this.selectedGroupSchedule.length > 0) {
        groupIds = this.selectedGroupSchedule.join(",");
      } else {
        groupIds = "";
      }

      if (this.selectedModelSchedule.length > 0) {
        model = this.selectedModelSchedule.join(",");
      } else {
        model = "";
      }

      if (this.selectedJobSiteSchedule.length > 0) {
        jobSite = this.selectedJobSiteScheduleName.join(";");
      } else {
        jobSite = "";
      }
      if (this.selectedZoneSchedule.length > 0) {
        zone = this.selectedZoneSchedule.join(",");
      } else {
        zone = "";
      }
      let searchValue = "";
      if (this.searchFieldPOSchedule) {
        searchValue = this.searchFieldPOSchedule;
      } else {
        searchValue = "";
      }
      let searchValue1 = "";
      if (this.searchFieldJobSchedule) {
        searchValue1 = this.searchFieldJobSchedule;
      } else {
        searchValue1 = "";
      }
      let searchValue2 = "";
      if (this.searchEquipNameSchedule) {
        searchValue2 = this.searchEquipNameSchedule;
      } else {
        searchValue2 = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id, cust;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        cust = "";
        id = "";
      } else {
        cust = this.$store.getters.companyNameDropdown;
        id = this.$store.getters.companyIdDropdown;
      }

      let parameters = [
        {
          name: "machineIds",
          value: machineIds,
        },
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },

        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "searchKeyJob",
          value: searchValue1,
        },
        {
          name: "searchKeyName",
          value: searchValue2,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        reportId: this.reportName,
        parameters: parameters,
        customer: String(id),
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",

        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        customerName: cust,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
        timeframe: this.scheduledtimeframe,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };
      try {
        let response = await telematicsService.createScheduledReport(payload);
        if (response.isSuccess) {
          this.isSaveScheduleLoading = false;
          this.$toast.success(" Schedule report  created successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isSaveScheduleLoading = false;
          this.reportDataList = [];
          this.columnSeries = [];
        }
      } catch (err) {
        console.log(err);
        this.isSaveScheduleLoading = false;
      }
    },
    async UpdateSchedule() {
      this.isupdateScheduleLoading = true;
      let machineIds, zone, groupIds, jobSite, model;

      if (this.selectedMachineSchedule.length > 0) {
        machineIds = this.selectedMachineSchedule.join(",");
        console.log(machineIds);
      } else {
        machineIds = "";
      }
      if (this.selectedGroupSchedule.length > 0) {
        groupIds = this.selectedGroupSchedule.join(",");
      } else {
        groupIds = "";
      }

      if (this.selectedModelSchedule.length > 0) {
        model = this.selectedModelSchedule.join(",");
      } else {
        model = "";
      }

      if (this.selectedJobSiteSchedule.length > 0) {
        jobSite = this.selectedJobSiteScheduleName.join(";");
      } else {
        jobSite = "";
      }
      if (this.selectedZoneSchedule.length > 0) {
        zone = this.selectedZoneSchedule.join(",");
      } else {
        zone = "";
      }
      let searchValue = "";
      if (this.searchFieldPOSchedule) {
        searchValue = this.searchFieldPOSchedule;
      } else {
        searchValue = "";
      }
      let searchValue1 = "";
      if (this.searchFieldJobSchedule) {
        searchValue1 = this.searchFieldJobSchedule;
      } else {
        searchValue1 = "";
      }
      let searchValue2 = "";
      if (this.searchEquipNameSchedule) {
        searchValue2 = this.searchEquipNameSchedule;
      } else {
        searchValue2 = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        // cust = "All";
        id = "";
      } else {
        // cust = this.$store.getters.companyIdDropdown;
        id = this.$store.getters.companyIdDropdown;
      }
      this.series = [];

      let parameters = [
        {
          name: "machineIds",
          value: machineIds,
        },
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        // {
        //   "name": "utilizationTargetValue",
        //    "value": String(this.dailyUtilizationTargetSchedule)
        // },

        // {
        //   "name": "utilizationTargetType",
        //   "value": this.selectedTimeSchedule
        // },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "searchKeyJob",
          value: searchValue1,
        },
        {
          name: "searchKeyName",
          value: searchValue2,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        id: this.selectedschedule.id,
        reportId: this.reportName,
        parameters: parameters,
        customer: String(id),
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",

        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        customerName: this.selectedcust,
        frequency: this.scheduledFrequency,
        timeframe: this.scheduledtimeframe,
        format: this.scheduledType,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };
      console.log(payload);
      try {
        let response = await telematicsService.updateScheduledReport(
          this.selectedschedule.id,
          payload
        );
        if (response.isSuccess) {
          this.isupdateScheduleLoading = false;
          this.$toast.success(" Schedule report  updated successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isupdateScheduleLoading = false;
          // this.reportDataList = [];
          // this.columnSeries = [];
        }
      } catch (err) {
        console.log(err);
        this.isupdateScheduleLoading = false;
      }
    },

    async getScheduledList() {
      this.isScheduledListLoading = true;
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        // cust = "All";
        id = "";
      } else {
        // cust = this.$store.getters.companyIdDropdown;
        id = this.$store.getters.companyIdDropdown;
      }
      //
      try {
        let response = await telematicsService.getScheduledReportList(
          String(id),
          String(this.reportName)
        );

        if (response.isSuccess) {
          this.isScheduledListLoading = false;
          this.scheduledList = response.data;
        } else {
          this.isScheduledListLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isScheduledListLoading = false;
      }
    },
    confirmDelete(item) {
      this.confirmdialog = true;
      this.selectedschedule = item;
    },
    async deleteSchedule() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteSchedule(
          this.selectedschedule.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Deleted Schedule report successfully");
          this.clearSchedule();
          this.displayScheduledForm = false;
          this.getScheduledList();
          this.confirmdialog = false;
          this.selectedschedule = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Schedule report" + err);
      }
    },
    OnFrequencyChange() {
      this.selectedDays = [];
      this.selectMonthlyDay = null;
    },

    async getZones() {
      this.loadingzones = true;
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
          this.loadingzones = false;
        } else {
          this.zonesList = [];
          this.loadingzones = false;
        }
      } catch (err) {
        console.log(err);
        this.loadingzones = false;
      }
    },
    async getGroups() {
      try {
        this.loadinggroups = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loadinggroups = false;
        }
      } catch (err) {
        this.loadinggroups = false;
        console.log(err);
      }
    },

    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loadingmodel = false;
        console.log(err);
      }
    },
    async getJobSites() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
          this.loadinglocations = false;
        } else {
          this.jobSiteList = [];
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },

    // end scheduled reports methods
  },
};
